<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-03-31 14:51:38
 * @LastEditTime: 2026-07-09 08:46:26
 * @LastEditors: hexy 913752270@qq.com
 * @Description  : 产品价格
 * @FilePath: \ICPSxin\src\views\platform\ICPS\internetSales\dialog\productPriceDialog.vue
-->
<template>
  <el-dialog :visible.sync="productPriceDialog" width="1100px" :append-to-body="true" :close-on-click-modal="false" :before-close="close" @open="openProductPriceDig">
    <span slot="title" class="dialog-title">产品价格配置</span>
    <div class="dialoginfo">
      <el-row>
        <el-col :span="16"> 生效日期:年-月-日 时-分-秒 </el-col>
        <el-col :span="5" :offset="3">
          <el-button class="bottom_all" style="margin-left: 24px" @click="priceSet()">调价设置</el-button>
        </el-col>
      </el-row>
      <!-- 1.强度等级表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="strengthData" tooltip-effect="dark">
          <el-table-column prop="askName" label="强度等级" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 100%"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="computePrice(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
          <!-- <el-table-column prop="priceDifference" label="最新调整含税价格" width="auto" align="center">
            <template slot-scope="scope">
              {{ scope.row.priceDifference ? scope.row.priceIncludinTax * 1 + scope.row.priceDifference * 1 : scope.row.priceIncludinTax }}
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" width="auto" align="center">
            <template slot-scope="scope">
              <el-link type="success" :underline="false" @click="changePriceNote(scope.row)">调价记录</el-link>
            </template>
          </el-table-column> -->
        </el-table>
      </el-row>
      <!-- 2.性能等级表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="functionData" tooltip-effect="dark">
          <el-table-column prop="askName" label="性能等级" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 100%"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="computePrice(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 3.材料要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="materialData" tooltip-effect="dark">
          <el-table-column prop="askName" label="材料要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 100%"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="computePrice(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 4.特殊要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="specialData" tooltip-effect="dark">
          <el-table-column prop="askName" label="特殊要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 100%"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="computePrice(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 5.外加剂要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="admixtureData" tooltip-effect="dark">
          <el-table-column prop="askName" label="外加剂要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 100%"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="computePrice(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 6.其他要求表格 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="otherData" tooltip-effect="dark">
          <el-table-column prop="askName" label="其他要求" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 100%"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="computePrice(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 7.组合类型 -->
      <el-row style="margin-top: 20px">
        <el-button v-if="!isLook" class="bottom_all_two" @click="addProductComposePriceDig = true">添加其他组合</el-button>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="productComposePriceList" tooltip-effect="dark">
          <el-table-column prop="productName" label="组合类型" width="auto" align="center"> </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 100%"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="computePrice(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
          <el-table-column prop="" label="操作" width="auto" align="center">
            <template slot-scope="scope">
              <el-link v-if="!isLook" type="danger" :underline="false" @click="deleteProductComposePrice(scope.$index)">删除</el-link>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <!-- 8.特殊产品 -->
      <el-row style="margin-top: 20px">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="productTypes" tooltip-effect="dark">
          <el-table-column prop="productName" label="特殊产品" width="auto" align="center"> </el-table-column>
          <el-table-column prop="costStandard" label="费用标准" width="auto" align="center">
            <template slot-scope="scope">
              <el-select v-model="scope.row.costStandard" :disabled="isLook" placeholder="请选择">
                <el-option :key="0" label="不收费" :value="0"> </el-option>
                <el-option :key="1" label="按车收费" :value="1"> </el-option>
                <el-option :key="2" label="按方量收费" :value="2"> </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="priceIncludinTax" label="含税价格" width="auto" align="center">
            <template slot-scope="scope">
              <el-input
                v-model="scope.row.priceIncludinTax"
                :disabled="isLook"
                type="Number"
                style="width: 100%"
                @input="scope.row.priceIncludinTax = $regExp.checkNum4(scope.row.priceIncludinTax)"
                @blur="computePrice(scope.row), (scope.row.priceIncludinTax = $regExp.blurCheckNum(scope.row.priceIncludinTax))" @mousewheel.native.prevent
              >
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="priceExcludingTax" label="不含税价格" width="auto" align="center"> </el-table-column>
        </el-table>
      </el-row>
      <!-- 结尾 -->
      <div>
        <div style="display: flex; flex-direction: row; justify-content: flex-start; align-items: center; margin-top: 10px">
          <div>同比例砂浆：</div>
          <el-select
            ref="strengthGradeId"
            v-model="mortar.strengthGradeId"
            disabled
            placeholder="请选择"
            style="width: 120px"
            @change="
              $nextTick(() => {
                mortar.strengthGrade = $refs.strengthGradeId.selectedLabel;
              })
            "
          >
            <el-option v-for="item in mortarTypeList" :key="item.id" :label="item.name" :value="item.id + ''"> </el-option>
          </el-select>
          <div style="margin-left: 10px">类型：</div>
          <el-select v-model="mortar.type" :disabled="isLook" placeholder="请选择" style="width: 120px">
            <el-option key="1" label="倍数" :value="1"> </el-option>
            <el-option key="2" label="固定金额" :value="2"> </el-option>
          </el-select>
          <div style="margin-left: 10px">{{ mortar.type == 2 ? "固定金额:" : "倍数:" }}</div>
          <el-input v-model="mortar.multiple" :disabled="isLook" style="width: 120px" placeholder="请输入内容"> </el-input>
        </div>
        <div style="display: flex; flex-direction: row; justify-content: flex-start; margin-top: 10px">
          <div style="margin-right: 10px">上传附件:</div>
          <FileComponent2 fileCode="priceFile" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button class="bottom_all_two" @click="close()">取 消</el-button>
      <el-button v-if="!isLook" class="bottom_all" style="margin-left: 24px" @click="save()">确 定</el-button>
    </span>
    <!-- 调价记录 -->
    <el-dialog v-dialogDrag :visible.sync="changePriceNoteDig" width="960px" :append-to-body="true" :close-on-click-modal="false" :before-close="closeChangePriceNote">
      <span slot="title" class="dialog-title">调价记录</span>
      <div class="dialoginfo">
        <el-button class="bottom_all_two" @click="queryGradeAjustResord">重新获取</el-button>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" border stripe style="width: 100%" height="350" :data="changePriceNoteList" tooltip-effect="dark">
          <el-table-column v-for="(item, index) in changePriceTable" :key="index" :prop="item.prop" :label="item.label" :width="item.width" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row[item.prop] || "*" }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeChangePriceNote()">关 闭</el-button>
      </span>
    </el-dialog>
    <!-- 添加组合类型 -->
    <el-dialog v-dialogDrag :visible.sync="addProductComposePriceDig" width="680px" :append-to-body="true" :close-on-click-modal="false" :before-close="closeProductComposePrice">
      <span slot="title" class="dialog-title">添加组合</span>
      <div class="dialoginfo">
        <el-form :model="ProductComposePriceForm" class="demo-form" label-width="auto">
          <el-form-item label="强度等级：">
            <el-select ref="function" v-model="ProductComposePriceForm.strengthGrade" value-key="name" placeholder="请选择">
              <el-option v-for="item in disclose.strengthGrade" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="性能等级：">
            <el-select ref="function" v-model="ProductComposePriceForm.function" value-key="name" multiple placeholder="请选择" @change="changeFunction">
              <el-option v-for="item in disclose.performanceGrade" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材料要求：">
            <el-select ref="material" v-model="ProductComposePriceForm.material" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in disclose.meterialRequirements" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="特殊要求：">
            <el-select ref="special" v-model="ProductComposePriceForm.special" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in disclose.specialRequirements" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="外加剂要求：">
            <el-select ref="admixture" v-model="ProductComposePriceForm.admixture" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in disclose.admixtureRequirements" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="其他要求：">
            <el-select ref="other" v-model="ProductComposePriceForm.other" value-key="name" multiple placeholder="请选择">
              <el-option v-for="item in disclose.otherRequirements" :key="item.name" :label="item.name" :value="item"> </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeProductComposePrice()">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="addProductComposePrice()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 调价设置 -->
    <el-dialog v-dialogDrag :visible.sync="changePriceDig" width="1100px" :append-to-body="true" :close-on-click-modal="false" :before-close="closeChangePrice">
      <span slot="title" class="dialog-title">调价设置</span>
      <div class="dialoginfo">
        <el-form ref="changePriceForm" :model="changePriceForm" :rules="changePriceRules" class="demo-form" label-width="auto">
          <el-row>
            <el-col :span="12">
              <el-form-item label="城市：" prop="cityCode">
                <el-select
                  ref="cityCode"
                  v-model="changePriceForm.cityCode"
                  :disabled="isLook"
                  placeholder="请选择"
                  clearable
                  @change="
                    $nextTick(() => {
                      changePriceForm.cityName = $refs.cityCode.selectedLabel;
                      selectCity();
                    })
                  "
                >
                  <el-option :key="1" label="成都" value="chendu"> </el-option>
                  <el-option :key="2" label="重庆" value="chongqing"> </el-option>
                  <el-option :key="3" label="绵竹" value="mianzhu"> </el-option>
                  <el-option :key="4" label="遂宁" value="suining"> </el-option>
                  <el-option :key="5" label="资阳" value="ziyang"> </el-option>
                  <el-option :key="6" label="德阳" value="deyang"> </el-option>
                  <el-option :key="7" label="眉山" value="meishan"> </el-option>
                  <el-option :key="8" label="宜宾" value="yibin"> </el-option>
                  <el-option :key="9" label="内江" value="neijiang"> </el-option>
                  <el-option :key="10" label="西昌" value="xichang"> </el-option>
                  <el-option :key="11" label="绵阳" value="mianyang"> </el-option>
                  <el-option :key="12" label="广安" value="guangan"> </el-option>
                  <el-option :key="13" label="达州" value="dazhou"> </el-option>
                  <el-option :key="14" label="南充" value="nanchong"> </el-option>
                  <el-option :key="15" label="乐山" value="leshan"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="参考区域：" prop="areaId">
                <el-select
                  ref="areaId"
                  v-model="changePriceForm.areaId"
                  :disabled="isLook"
                  placeholder="请选择"
                  clearable
                  @change="
                    $nextTick(() => {
                      changePriceForm.area = $refs.areaId.selectedLabel;
                    })
                  "
                >
                  <el-option v-for="item in areaList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="基准价（含税）：" prop="benchmarkType">
                <el-select v-model="changePriceForm.benchmarkType" :disabled="isLook" placeholder="请选择">
                  <el-option :key="1" label="《建筑工程造价信息》公布基准价" :value="1"> </el-option>
                  <el-option :key="2" label="自定义基准价" :value="2"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <div v-if="changePriceForm.benchmarkType == 1">
            <el-row>
              <el-col :span="12">
                <el-form-item label="基准价参考期数：" prop="benchmarkPeriodsId">
                  <el-select
                    ref="benchmarkPeriodsId"
                    v-model="changePriceForm.benchmarkPeriodsId"
                    :disabled="isLook"
                    placeholder="请选择"
                    clearable
                    @change="
                      $nextTick(() => {
                        changePriceForm.benchmarkPeriods = $refs.benchmarkPeriodsId.selectedLabel;
                        selectBenchmarkPeriods();
                      })
                    "
                  >
                    <el-option v-for="item in benchmarkPeriodsList" :key="item.id" :label="item.montageName" :value="item.id"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="参考标号：" prop="benchmarkGradeId">
                  <el-select
                    ref="benchmarkGradeId"
                    v-model="changePriceForm.benchmarkGradeId"
                    :disabled="isLook"
                    placeholder="请选择"
                    clearable
                    @change="
                      $nextTick(() => {
                        changePriceForm.benchmarkGrade = $refs.benchmarkGradeId.selectedLabel;
                      })
                    "
                  >
                    <el-option v-for="item in basePatternList" :key="item.gradeId" :label="item.itemName" :value="item.gradeId"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <el-row v-if="changePriceForm.benchmarkType == 2">
            <el-col :span="12">
              <el-form-item label="基准价：" prop="benchmarkPrice">
                <el-input v-model="changePriceForm.benchmarkPrice" :disabled="isLook" type="Number" style="width: 100%" @mousewheel.native.prevent> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="结算月信息价对应：" prop="corresponding">
                <el-select v-model="changePriceForm.corresponding" :disabled="isLook" placeholder="请选择" @change="changeCorresponding()">
                  <el-option :key="1" label="当期对当月" :value="1"> </el-option>
                  <el-option :key="2" label="合同指定月" :value="2"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="结算月信息价（含税）：" prop="monthlySettlementPriceType">
                <el-select v-model="changePriceForm.monthlySettlementPriceType" :disabled="isLook" placeholder="请选择">
                  <el-option :key="1" label="信息价" :value="1" :disabled="changePriceForm.corresponding == 2"> </el-option>
                  <el-option :key="2" label="信息价加权平均" :value="2"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            
          </el-row>
          <el-row>
            <!-- <el-col v-if="changePriceForm.corresponding == 2" :span="12"> -->
            <el-col :span="12">
              <el-form-item v-if="changePriceForm.corresponding != 1" label="信息价指定月：" >
                <el-select v-model="changePriceForm.correspondingMouth" placeholder="请选择">
                  <el-option :key="0" label="当月" :value="0"> </el-option>
                  <el-option :key="1" label="上一月" :value="1"> </el-option>
                  <el-option :key="2" label="上二月" :value="2"> </el-option>
                  <el-option :key="3" label="上三月" :value="3"> </el-option>
                  <el-option :key="4" label="上四月" :value="4"> </el-option>
                  <el-option :key="5" label="上五月" :value="5"> </el-option>
                  <el-option :key="6" label="上六月" :value="6"> </el-option>
                  <el-option :key="7" label="上七月" :value="7"> </el-option>
                  <el-option :key="8" label="上八月" :value="8"> </el-option>
                  <el-option :key="9" label="上九月" :value="9"> </el-option>
                  <el-option :key="10" label="上十月" :value="10"> </el-option>
                  <el-option :key="11" label="上十一月" :value="11"> </el-option>
                  <el-option :key="12" label="上十二月" :value="12"> </el-option>
                </el-select>
              </el-form-item>
              <!-- <el-form-item label="信息价指定月：" prop="correspondingMouth" >
                <el-select v-model="changePriceForm.correspondingMouth" :disabled="isLook" placeholder="请选择">
                  <el-option :key="0" label="当月" :value="0"> </el-option>
                  <el-option :key="1" label="上一月" :value="1"> </el-option>
                  <el-option :key="2" label="上二月" :value="2"> </el-option>
                  <el-option :key="3" label="上三月" :value="3"> </el-option>
                  <el-option :key="4" label="上四月" :value="4"> </el-option>
                  <el-option :key="5" label="上五月" :value="5"> </el-option>
                  <el-option :key="6" label="上六月" :value="6"> </el-option>
                  <el-option :key="7" label="上七月" :value="7"> </el-option>
                  <el-option :key="8" label="上八月" :value="8"> </el-option>
                  <el-option :key="9" label="上九月" :value="9"> </el-option>
                  <el-option :key="10" label="上十月" :value="10"> </el-option>
                  <el-option :key="11" label="上十一月" :value="11"> </el-option>
                  <el-option :key="12" label="上十二月" :value="12"> </el-option>
                </el-select>
              </el-form-item> -->
            </el-col>
            <el-col :span="12">
              <el-form-item label="参考标号：" prop="monthlySettlementGradeId">
                <el-select
                  ref="monthlySettlementGradeId"
                  v-model="changePriceForm.monthlySettlementGradeId"
                  :disabled="isLook"
                  placeholder="请选择"
                  clearable
                  @change="
                    $nextTick(() => {
                      changePriceForm.monthlySettlementGrade = $refs.monthlySettlementGradeId.selectedLabel;
                    })
                  "
                >
                  <el-option v-for="item in infoPatternList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="价差值计算税率：" prop="calculateTaxRate">
                <el-radio-group v-model="changePriceForm.calculateTaxRate" :disabled="isLook">
                  <el-radio :label="1">是</el-radio>
                  <el-radio :label="0">否</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="固定金额(含税)：" prop="otherFixed">
                <el-input v-model="changePriceForm.otherFixed" :disabled="isLook" type="Number" style="width: 140px" @mousewheel.native.prevent> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="调价涨跌方式：" prop="priceUpAndDownType">
                <el-select v-model="changePriceForm.priceUpAndDownType" :disabled="isLook" placeholder="请选择" @change="changePriceUpAndDownType()">
                  <el-option :key="1" label="比例" :value="1"> </el-option>
                  <el-option :key="2" label="浮动值" :value="2"> </el-option>
                  <el-option :key="3" label="价差值" :value="3"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- 比例表单 -->
          <div v-if="changePriceForm.priceUpAndDownType == 1">
            <el-row>比例=（基础价-信息价）/基础价*100%</el-row>
            <el-row style="margin-top: 20px">
              <el-col :span="5">
                <el-form-item label="比例" prop="priceUpAndDownCondition">
                  <el-select v-model="changePriceForm.priceUpAndDownCondition" :disabled="isLook" placeholder="请选择" style="width: 150px">
                    <el-option :key="1" label="＜" :value="1"> </el-option>
                    <el-option :key="2" label="≤" :value="2"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="±" prop="priceUpAndDownConditionValue">
                  <el-input v-model="changePriceForm.priceUpAndDownConditionValue" :disabled="isLook" type="Number" style="width: 140px" @mousewheel.native.prevent> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="%" prop="priceUpAndDownAdjustResult">
                  <el-select v-model="changePriceForm.priceUpAndDownAdjustResult" disabled placeholder="请选择" style="width: 140px">
                    <el-option :key="1" label="调整" :value="1"> </el-option>
                    <el-option :key="2" label="不调整" :value="2"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <el-form-item label="比例">
                  <span v-if="changePriceForm.priceUpAndDownCondition == 1" style="width: 100px; display: flex">≥</span>
                  <span v-if="changePriceForm.priceUpAndDownCondition == 2" style="width: 100px; display: flex">＞</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="±">
                  <span style="width: 100px; display: flex">{{ changePriceForm.priceUpAndDownConditionValue }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="%">
                  <span v-if="changePriceForm.priceUpAndDownAdjustResult == 1" style="width: 100px; display: flex">不调整</span>
                  <span v-if="changePriceForm.priceUpAndDownAdjustResult == 2" style="width: 100px; display: flex">调整</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-radio-group v-model="changePriceForm.proportionType" :disabled="isLook">
                <el-radio label="1">参考标号价差值（超出价差比例部分）</el-radio>
                <el-radio label="2">参考标号价差比例（超出价差比例部分）</el-radio>
                <el-radio label="4">参考标号价差值（全调）</el-radio>
                <el-radio label="5">参考标号价差比例（全调）</el-radio>
              </el-radio-group>
            </el-row>
            <el-row v-show="changePriceForm.proportionType == '1'">调增：（信息价>基准价）结算单价=对应标号合同价+参考标号信息价-参考标号基准价*（1+维护比例）</el-row>
            <el-row v-show="changePriceForm.proportionType == '1'">调减：（信息价<span v-text="'<'"></span>基准价）结算单价=对应标号合同价+参考标号信息价信息价-参考标号基准价*（1-维护比例）</el-row>
            <el-row v-show="changePriceForm.proportionType == '2'">调增：（信息价>基准价）结算单价=对应标号合同价*（参考标号信息价/参考标号基准价-维护比例）</el-row>
            <el-row v-show="changePriceForm.proportionType == '2'">调减：（信息价<span v-text="'<'"></span>基准价）结算单价=对应标号合同价*（参考标号信息价/参考标号基准价+维护比例）</el-row>
            <el-row v-show="changePriceForm.proportionType == '4'">结算单价=对应标号合同价+参考标号信息价-参考标号基准价</el-row>
            <el-row v-show="changePriceForm.proportionType == '5'">结算单价=对应标号合同价*（对应标号信息价/对应标号基准价）</el-row>
          </div>
          <!-- 浮动值表单 -->
          <div v-if="changePriceForm.priceUpAndDownType == 2">
            <el-row>浮动值=信息价-基准价</el-row>
            <el-row style="margin-top: 20px">
              <el-col :span="5">
                <el-form-item label="浮动值" prop="priceUpAndDownCondition">
                  <el-select v-model="changePriceForm.priceUpAndDownCondition" :disabled="isLook" placeholder="请选择" style="width: 150px">
                    <el-option :key="1" label="＜" :value="1"> </el-option>
                    <el-option :key="2" label="≤" :value="2"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="±" prop="priceUpAndDownConditionValue">
                  <el-input v-model="changePriceForm.priceUpAndDownConditionValue" :disabled="isLook" type="Number" style="width: 140px" @mousewheel.native.prevent> </el-input>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="元" prop="priceUpAndDownAdjustResult">
                  <el-select v-model="changePriceForm.priceUpAndDownAdjustResult" disabled placeholder="请选择" style="width: 140px">
                    <el-option :key="1" label="调整" :value="1"> </el-option>
                    <el-option :key="2" label="不调整" :value="2"> </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="5">
                <el-form-item label="浮动值">
                  <span v-if="changePriceForm.priceUpAndDownCondition == 1" style="width: 140px; display: flex">≥</span>
                  <span v-if="changePriceForm.priceUpAndDownCondition == 2" style="width: 140px; display: flex">＞</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="±">
                  <span style="width: 100px; display: flex">{{ changePriceForm.priceUpAndDownConditionValue }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="4">
                <el-form-item label="元">
                  <span v-if="changePriceForm.priceUpAndDownAdjustResult == 1" style="width: 140px; display: flex">不调整</span>
                  <span v-if="changePriceForm.priceUpAndDownAdjustResult == 2" style="width: 140px; display: flex">调整</span>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>调增：（信息价>基准价）价差=信息价-（基准价+维护浮动值）</el-row>
            <el-row>调减：（信息价<span v-text="'<'"></span>基准价）价差=信息价-（基准价-维护浮动值）</el-row>
            <el-row>结算单价=合同价+价差</el-row>
          </div>
          <!-- 价差值值表单 -->
          <div v-if="changePriceForm.priceUpAndDownType == 3">
            <!-- <el-row>调增：（信息价>基准价）价差=信息价-基准价</el-row>
            <el-row>调减：（信息价<span v-text="'<'"></span>基准价）价差=基准价-信息价</el-row> -->
            <el-row>结算单价=合同价+(信息价-基准价)</el-row>
          </div>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="closeChangePrice()">取 消</el-button>
        <el-button v-if="!isLook" class="bottom_all" style="margin-left: 24px" @click="saveChangePrice()">确 定</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import {
  queryReadjustCostDetail,
  queryGradeAjustResord,
  queryDisclose,
  saveOrUpdateConsultPrice,
  queryPeriodsByCity,
  queryAreaByPeriods,
  queryGradeList,
  queryPriceRule,
  saveOrUpdatePriceRule,
} from "@/api/internetSales/engineeringControl.js";
import { queryPatternList } from "@/api/basicConfig/priceMaintenance.js";
import FileComponent2 from "@/views/platform/ICPS/internetSales/components/fileComponent";
import { updateStatus } from "@/api/internetSales/engineeringControl.js";
export default {
  components: {
    FileComponent2,
  },
  props: {
    productPriceDialog: {
      type: Boolean,
      default: false,
    },
    isLook: {
      type: Boolean,
      default: false,
    },
    engineeringId: {
      type: String,
      default: "",
    },
    data: {
      type: Object,
      default: () => {},
    },
    engineeringInfo: {
      type: Object,
      default: new Object(),
    },
  },
  data() {
    return {
      taxRate: 0, //税率
      mortar: {
        multiple: 0,
        type: 1,
        strengthGradeId: "0001",
        strengthGrade: "相同强度",
      }, //同比例砂浆
      strengthData: [], //强度等级
      functionData: [], //性能等级
      materialData: [], //材料要求
      specialData: [], //特殊要求
      admixtureData: [], //外加剂要求
      otherData: [], //其他要求
      productComposePriceList: [], //组合类型
      productTypes: [], //特殊产品
      changePriceNoteList: [], //调价记录列表
      chooseStrengthRow: {},
      changePriceNoteDig: false,
      addProductComposePriceDig: false,
      ProductComposePriceForm: {
        function: [],
        material: [],
        special: [],
        admixture: [],
        other: [],
        strengthGrade:{},
      },
      disclose: {}, //交底信息
      mortarTypeList: [
        {
          id: "0001",
          name: "相同强度",
        },
      ],
      changePriceTable: [
        { label: "强度等级", width: "auto", prop: "strengthGrade", status: true },
        { label: "合同价", width: "auto", prop: "priceType", status: true },
        { label: "基准价", width: "auto", prop: "taxRate", status: true },
        { label: "信息价地区", width: "auto", prop: "createUserName", status: true },
        { label: "期数", width: "auto", prop: "createUserName", status: true },
        { label: "当期信息价", width: "auto", prop: "createUserName", status: true },
        { label: "价差", width: "auto", prop: "createUserName", status: true },
        { label: "结算价", width: "auto", prop: "createUserName", status: true },
        { label: "生效时间", width: "auto", prop: "createUserName", status: true },
        { label: "调整时间", width: "auto", prop: "createTime", status: true },
      ],
      files: [],
      //调价记录表单
      changePriceForm: {
        readjustPricesResordId: "",
        cityCode: "",
        cityName: "",
        benchmarkType: 1,
        benchmarkPeriodsId: "",
        benchmarkPeriods: "",
        area: "",
        areaId: "",
        benchmarkGrade: "",
        benchmarkGradeId: "",
        monthlySettlementPriceType: "",
        corresponding: "",
        correspondingMouth: "",
        monthlySettlementGradeId: "",
        monthlySettlementGrade: "",
        calculateTaxRate: 0,
        otherFixed:0,
        priceUpAndDownType: 1,
        priceUpAndDownCondition: 1,
        priceUpAndDownConditionValue: "",
        priceUpAndDownAdjustResult: 2,
        proportionType: "1",
      },
      changePriceRules: {
        cityCode: [{ required: true, message: "请选择城市", trigger: "change" }],
        benchmarkType: [{ required: true, message: "请选择基准价（含税）", trigger: "change" }],
        benchmarkPeriodsId: [{ required: true, message: "请选择基准价参考期数", trigger: "change" }],
        areaId: [{ required: true, message: "请选择参考区域", trigger: "change" }],
        benchmarkGradeId: [{ required: true, message: "请选择参考标号", trigger: "change" }],
        benchmarkPrice: [{ required: true, message: "请输入基准价", trigger: "change" }],
        monthlySettlementPriceType: [{ required: true, message: "请选择结算月信息价（含税）", trigger: "change" }],
        corresponding: [{ required: true, message: "结算月信息价对应", trigger: "change" }],
        correspondingMouth: [{ required: true, message: "结算月信息价合同指定月", trigger: "change" }],
        monthlySettlementGradeId: [{ required: true, message: "请选择参考标号", trigger: "change" }],
        priceUpAndDownType: [{ required: true, message: "请选择调价涨跌方式", trigger: "change" }],
        calculateTaxRate: [{ required: true, message: "请选择价差值计算税率", trigger: "change" }],
        //   priceUpAndDownCondition:[
        //     { required: true, message: '请选择调价涨跌方式符号', trigger: 'change' }
        //   ],
        // priceUpAndDownConditionValue:[
        //   { required: true, message: '请输入调价涨跌比例', trigger: 'change' }
        // ],
        //   priceUpAndDownAdjustResult:[
        //     { required: true, message: '请选择调价涨跌结果', trigger: 'change' }
        //   ],
      },
      changePriceDig: false,
      benchmarkPeriodsList: [], //期数
      areaList: [], //区域
      basePatternList: [], //基准价标号
      infoPatternList: [], //信息价标号
    };
  },
  methods: {
    changeCorresponding(){
      if(this.changePriceForm.corresponding == 1){
        this.changePriceForm.correspondingMouth = 0
      }
    },
    changePriceUpAndDownType() {
      if (this.changePriceForm.priceUpAndDownType == 1) {
        this.changePriceForm.priceUpAndDownCondition = 1;
        this.changePriceForm.priceUpAndDownAdjustResult = 2;
        this.changePriceForm.proportionType = "1";
      }
    },
    selectBenchmarkPeriods() {
      //获取基准价标号区域
      if (this.changePriceForm.benchmarkType == 1) {
        queryAreaByPeriods({ periodsId: this.changePriceForm.benchmarkPeriodsId, type: 1 }).then(res => {
          if (res.code == 1001) {
            //this.areaList = res.data.tableArea;
            this.basePatternList = res.data.tableLable;
            // this.basePatternList.unshift({ id: "0001", itemName: "对应标号" });
          }
        });
      }
    },
    selectCity() {
      //获取期数
      queryPeriodsByCity({ code: this.changePriceForm.cityCode }).then(res => {
        if (res.code == 1001) {
          this.benchmarkPeriodsList = res.data;
        }
      });
      //获取城市
      queryPatternList({ cityDode: this.changePriceForm.cityCode }).then(res => {
        if (res.code == 1001) {
          this.areaList = res.data.areaList;
        }
      });
      //获取信息价标号
      queryGradeList({ informationPriceType: 1, cityDode: this.changePriceForm.cityCode, type: 1, typeId: 1 }).then(res => {
        if (res.code == 1001) {
          this.infoPatternList = res.data;
          // this.infoPatternList.unshift({ id: "0001", name: "对应标号" });
        }
      });
      this.changePriceForm.cityName = this.$refs.cityCode.selectedLabel;
    },
    changeFunction() {
      console.log(this.ProductComposePriceForm.function);
    },
    //关闭调价记录
    closeChangePriceNote() {
      this.changePriceNoteDig = false;
    },
    //调价记录
    changePriceNote(row) {
      this.chooseStrengthRow = row;
      this.changePriceNoteDig = true;
    },
    //获取调价记录
    queryGradeAjustResord() {
      queryGradeAjustResord({ gradeStrengthId: this.chooseStrengthRow.askId }).then(res => {
        if (res.code == 1001) {
          this.changePriceNoteList = res.data;
        }
      });
    },
    //添加其他组合
    addProductComposePrice() {
      let askName = "";
      if (
        this.ProductComposePriceForm.function.length == 0 &&
        this.ProductComposePriceForm.material.length == 0 &&
        this.ProductComposePriceForm.special.length == 0 &&
        this.ProductComposePriceForm.other.length == 0 &&
        this.ProductComposePriceForm.admixture.length == 0 && 
        !this.ProductComposePriceForm.strengthGrade.name
      ) {
        this.$message.warning("请选择一项要求再添加！");
        return;
      }
      //顺序:强度等级、性能、材料、特殊、其他、外加剂
      askName = askName + this.ProductComposePriceForm.strengthGrade.name;
      this.ProductComposePriceForm.function.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.material.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.special.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.other.forEach(item => {
        askName = askName + item.name;
      });
      this.ProductComposePriceForm.admixture.forEach(item => {
        askName = askName + item.name;
      });
      let item = {
        productName: askName,
        admixtureRequirements: JSON.stringify(this.ProductComposePriceForm.admixture),
        meterialRequirements: JSON.stringify(this.ProductComposePriceForm.material),
        otherRequirements: JSON.stringify(this.ProductComposePriceForm.other),
        performanceGrade: JSON.stringify(this.ProductComposePriceForm.function),
        priceExcludingTax: "",
        priceIncludinTax: "",
        specialRequirements: JSON.stringify(this.ProductComposePriceForm.special),
        strengthGrade: this.ProductComposePriceForm.strengthGrade.name,
        strengthGradeId: this.ProductComposePriceForm.strengthGrade.id
      };
      this.productComposePriceList.push(item);
      this.closeProductComposePrice();
    },
    //关闭其他组合
    closeProductComposePrice() {
      this.addProductComposePriceDig = false;
      this.ProductComposePriceForm = this.$options.data().ProductComposePriceForm;
    },
    //删除组合类型
    deleteProductComposePrice(index) {
      this.productComposePriceList.splice(index, 1);
    },
    //计算不含税单价
    computePrice(row) {
      row.priceExcludingTax = ((row.priceIncludinTax * 1) / (1 + this.taxRate)).toFixed(2) || "0.00";
    },
    //调价设置
    priceSet() {
      //获取调价设置
      queryPriceRule({ resordId: this.data.id }).then(res => {
        if (res.code == 1001) {
          this.changePriceDig = true;
          this.changePriceForm = this.$options.data().changePriceForm;
          this.changePriceForm = res.data ? res.data : this.$options.data().changePriceForm;
          this.changePriceForm.priceUpAndDownAdjustResult = 2; //默认显示不调整
          this.selectCity();
          this.selectBenchmarkPeriods();
          this.$refs.changePriceForm.clearValidate();
        }
      });
    },
    //保存调价设置
    saveChangePrice() {
      if (!this.changePriceForm.proportionType) {
        this.$message.warning("请勾选价差值或价差比例！");
        return;
      }
      // if(this.changePriceForm.proportionType == 3){
      //   if(this.changePriceForm.monthlySettlementGrade != this.changePriceForm.benchmarkGrade || this.changePriceForm.monthlySettlementGrade == '对应标号'){
      //     this.$message.warning("选择‘对应标号价差值’时，参考标号应一致且不为‘对应标号’！");
      //     return;
      //   }
      // }
      if (this.changePriceForm.priceUpAndDownType != 3 && !this.changePriceForm.priceUpAndDownConditionValue) {
        this.$message.warning("请输入调价比例！");
        return;
      }
      this.$refs["changePriceForm"].clearValidate()
      this.$refs["changePriceForm"].validate(valid => {
        if (valid) {
          this.changePriceForm.readjustPricesResordId = this.data.id;
          saveOrUpdatePriceRule(this.changePriceForm).then(res => {
            if (res.code == 1001) {
              this.$message.success("保存成功");
              this.queryReadjustCostDetail();
              this.closeChangePrice();
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //关闭调价设置
    closeChangePrice() {
      this.changePriceDig = false;
    },
    //打开弹窗请求数据
    openProductPriceDig() {
      this.taxRate = this.data.taxRate * 1;
      this.queryReadjustCostDetail();
      //获取交底信息
      queryDisclose({ engId: this.data.engineeringId }).then(res => {
        if (res.code == 1001) {
          res.data.performanceGrade.forEach(item => {
            delete item.type;
          });
          res.data.meterialRequirements.forEach(item => {
            delete item.type;
          });
          res.data.specialRequirements.forEach(item => {
            delete item.type;
          });
          res.data.admixtureRequirements.forEach(item => {
            delete item.type;
          });
          res.data.otherRequirements.forEach(item => {
            delete item.type;
          });
          this.disclose = res.data;
          this.mortarTypeList = this.$options.data().mortarTypeList;
          this.mortarTypeList = [...this.mortarTypeList, ...res.data.strengthGrade];
          console.log(this.mortarTypeList);
        }
      });
    },
    //请求页面数据
    queryReadjustCostDetail() {
      let params = {
        readjustPricesResordId: this.data.id,
        priceType: 1,
      };
      queryReadjustCostDetail(params).then(res => {
        this.strengthData = res.data.productAskMap.strengthGrade || [];
        this.functionData = res.data.productAskMap.performanceGrade || [];
        this.materialData = res.data.productAskMap.meterialRequirements || [];
        this.specialData = res.data.productAskMap.specialRequirements || [];
        this.admixtureData = res.data.productAskMap.admixtureRequirements || [];
        this.otherData = res.data.productAskMap.otherRequirements || [];
        this.productComposePriceList = res.data.productComposePriceList || [];
        this.productTypes = res.data.productTypes || [];
        if (res.data.mortar) {
          this.mortar = res.data.mortar;
          this.mortar.strengthGradeId = "0001";
          this.mortar.strengthGrade = "相同强度";
        }
        if (res.data.appendix) {
          this.files = JSON.parse(res.data.appendix) || [];
        }
      });
    },
    save() {
      let productAskList = [];
      this.strengthData.forEach(item => {
        let obj = {
          askId: item.askId,
          askName: item.askName,
          priceExcludingTax: item.priceExcludingTax,
          priceIncludinTax: item.priceIncludinTax,
          type: 1,
        };
        productAskList.push(obj);
      });
      this.functionData.forEach(item => {
        let obj = {
          askId: item.askId,
          askName: item.askName,
          priceExcludingTax: item.priceExcludingTax,
          priceIncludinTax: item.priceIncludinTax,
          type: 2,
        };
        productAskList.push(obj);
      });
      this.materialData.forEach(item => {
        let obj = {
          askId: item.askId,
          askName: item.askName,
          priceExcludingTax: item.priceExcludingTax,
          priceIncludinTax: item.priceIncludinTax,
          type: 3,
        };
        productAskList.push(obj);
      });
      this.specialData.forEach(item => {
        let obj = {
          askId: item.askId,
          askName: item.askName,
          priceExcludingTax: item.priceExcludingTax,
          priceIncludinTax: item.priceIncludinTax,
          type: 4,
        };
        productAskList.push(obj);
      });
      this.admixtureData.forEach(item => {
        let obj = {
          askId: item.askId,
          askName: item.askName,
          priceExcludingTax: item.priceExcludingTax,
          priceIncludinTax: item.priceIncludinTax,
          type: 5,
        };
        productAskList.push(obj);
      });
      this.otherData.forEach(item => {
        let obj = {
          askId: item.askId,
          askName: item.askName,
          priceExcludingTax: item.priceExcludingTax,
          priceIncludinTax: item.priceIncludinTax,
          type: 6,
        };
        productAskList.push(obj);
      });
      let type = false;
      this.productComposePriceList.forEach(item => {
        if (item.priceIncludinTax !== 0 && !item.priceIncludinTax) {
          type = true;
        }
      });
      // this.productTypes.forEach(item => {
      //   if (item.priceIncludinTax !== 0 && !item.priceIncludinTax) {
      //     type = true;
      //   }
      //   if (item.costStandard !== 0 && !item.costStandard) {
      //     type = true;
      //   }
      // });
      productAskList.forEach(item => {
        if (item.priceIncludinTax !== 0 && !item.priceIncludinTax) {
          type = true;
        }
      });
      if (type) {
        this.$message.warning("表格数据不允许为空!");
        return;
      }
      if (!this.mortar.type || !this.mortar.multiple) {
        this.$message.warning("同比例砂浆数据不允许为空!");
        return;
      }
      let params = {
        readjustPricesResordId: this.data.id,
        appendix: JSON.stringify(this.files),
        priceType: 1,
        productAskList: productAskList,
        productComposePriceList: this.productComposePriceList,
        mortar: this.mortar,
        productTypes: this.productTypes,
      };
      saveOrUpdateConsultPrice(params).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功！");
          this.close();
          if (this.data.sureMaintain == 0) {
            updateStatus({
              id: this.data.id,
              sureMaintain: 1,
            }).then(() => {
              this.close();
            })
          } else {
            this.close();
            let obj = {
              id: this.data.engineeringId,
              name: this.engineeringInfo.name,
              readjustPricesResordId: this.data.id,
              priceType:this.data.priceType,
              effectiveTime:this.data.effectiveTime,
            }
            this.$router.push({ name: "priceMaintenance_sign", query: { dataContent: JSON.stringify(obj), type: 1 } });
          }
        }
      });
    },
    close() {
      this.$emit("closeProductPriceDialog", false);
    },
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    uplodeSuccess(data) {
      const params = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(params);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>